import React, { useState } from "react";
import Page from "../../../components/general/page";
import VatDetailReportPage from "../../../components/report/vatSettlements/detail";
import VatMultiActivityReportPage from "../../../components/report/vatSettlements/multiActivity";
import { useLocation, useNavigate } from "react-router-dom";

const VatDetailReportView = props => {
  const location = useLocation();
  const navigate = useNavigate();
  const { pageRef } = props;
  const [isMultiactivity] = useState(location.state.settlement.businessSettlements.length >= 2); // TODO modify it when API will be connected
  const [singleBusinessId, setSingleBusinessId] = useState("");
  const [subtitle, setSubtitle] = useState("Riepilogo");

  const goToDetails = (businessId) => {
    setSingleBusinessId(businessId);    
    navigate(location.pathname, { state: location.state});
  };
  
  return (
    <Page
      pageRef={pageRef}
      title={"Liquidazione IVA"}
      subtitle={subtitle}
      actionClick={() => {        
        setSingleBusinessId(null);
        setSubtitle("Riepilogo");        
      }}    
      backUrl={"/reports/vat"}    
      backLocation={location.state}  
    >
      {
        !isMultiactivity /* || singleBusinessId*/
          ? <VatDetailReportPage  currentMonthSelected={location.pathname.split("vat-detail/")[1]} setSubtitleSection={setSubtitle} businessId={singleBusinessId ? singleBusinessId : location?.state?.settlement?.businessSettlements[0].id}/> 
          : <VatMultiActivityReportPage setSubtitleSection={setSubtitle} location={location} currentSettlement={location.state.settlement} goToDetails={goToDetails} businessId={singleBusinessId ? singleBusinessId : location.state.settlement.businessSettlements[0].id}/> 
      }
      
    </Page>
  );
};

export default VatDetailReportView;
